// extracted by mini-css-extract-plugin
module.exports = {"market":"styles_market__1tkrv","content":"styles_content__1XLwV"};